const styles = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FEFEFE',
    boxShadow: '0px 4px 4px 0px #000000',
    padding: '14px 24px',
    width: '700px',
  },
  boldText: { fontSize: '16px', fontWeight: '600', marginBottom: '8px' },
  smallText: { fontSize: '14px', fontWeight: '400' },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
  },
  button: {
    fontSize: '14px',
    fontWeight: '500',
  },
  textarea: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid gray',
    padding: '20px 16px',
    fontSize: '14px',
  },
  nameInput: {
    width: '300px',
    height: '22px',
    backgroundColor: '#C4C4C421',
    paddingLeft: '10px',
    marginLeft: 20,
  },
  senderSelector: {
    width: '120px',
    height: '22px',
    fontSize: '14px',
    color: '#8F8F8F',
    backgroundColor: 'transparent',
    marginLeft: '20px',
    marginBottom: 10,
  },
  wrapperSelect: {
    '& .MuiInput-root': {
      fontSize: '14px',
    },
  },
  input: {
    width: '100%',
    height: '30px',
    fontSize: '14px',
  },
  buttonOpen: { fontSize: '10px', color: '#7C7C7C', width: '100px' },
  inputContainer: {
    paddingTop: '6px',
  },
  messageInput: {
    width: '100%',
  },
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '140px',
    height: '60px',
    border: '1px dashed gray',
    color: '#777777',
    backgroundColor: '#ededed',
  },
  filesItem: {
    color: '#777777',
    fontSize: '14px',
    height: '20px',
    alignItems: 'center',
  },
  filesContainer: {
    paddingLeft: '16px',
    padding: '4px 0',
  },
  textArea: {
    resize: 'none',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%',
    padding: '10px',
    fontSize: '14px',
  },
  inputName: {
    fontSize: '14px',
    fontWeight: '400',
    width: '70px',
  },
  footer: {
    marginTop: '10px',
  },
  spaceBetween: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  menuItem: {
    fontSize: 12,
  },
  error: {
    fontSize: 12,
    color: '#f44336',
    marginTop: '-8px',
    marginBottom: 8,
  },
  submitButton: {
    height: 32,
  },
}

export default styles
